<template>
    <div class="accounting-detail-data accounting-loan-repayment-detail">
        <div class="detail-container">
            <div class="detail-section">
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item vertical">
                        <div class="label">摘要</div>
                        <div class="value xl b">還款 - {{ documentDetail.summary }}</div>
                    </div>
                </div>
                <div v-if="documentDetail.isMakeUpRegistration" style="color: red"><i class="el-icon-warning"></i> 此筆還款為補登紀錄，不扣款、不自動產生傳票。</div>
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item">
                        <div class="label">還借款</div>
                        <div class="value">{{ documentDetail.summary }}</div>
                    </div>
                    <div class="item">
                        <div class="label">借款編號</div>
                        <div class="value">{{ documentDetail.systemNo }}</div>
                    </div>
                    <div class="item">
                        <div class="label">還款日期</div>
                        <div class="value">{{ documentDetail.repaymentDate | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">還款總額</div>
                        <div class="value xl"><Money :v="documentDetail.principalAmount + documentDetail.interestAmount" /><span class="cny">TWD</span></div>
                    </div>
                    <div class="item">
                        <div class="label">備註</div>
                        <div class="value">{{ documentDetail.note || "--" }}</div>
                    </div>
                </div>
            </div>
            <!-- 存款帳戶支出 -->
            <div class="detail-section">
                <div class="section-title">存款帳戶支出</div>
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item">
                        <div class="label">扣款帳戶</div>
                        <div class="value">{{ documentDetail.repaymentBankName || '(無)' }}</div>
                    </div>
                    <div class="item">
                        <div class="label">扣款日期</div>
                        <div class="value">{{ documentDetail.repaymentDate | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">還款本金</div>
                        <div class="value xl"><Money :v="documentDetail.principalAmount" /><span class="cny">TWD</span></div>
                    </div>
                    <div class="item">
                        <div class="label">還款利息</div>
                        <div class="value xl"><Money :v="documentDetail.interestAmount" /><span class="cny">TWD</span></div>
                    </div>
                    <div class="item">
                        <div class="label">匯費</div>
                        <div class="value">
                            <div v-if="documentDetail.reM_FEE_AMT"><Money :v="documentDetail.reM_FEE_AMT" /><span class="cny">TWD</span></div>
                            <div v-else>(無)</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">匯費扣款帳戶</div>
                        <div class="value">
                            <div>{{ documentDetail.reM_FEE_BNK_NAM || '(無)'  }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 借款帳戶資訊 -->
            <div class="detail-section">
                <div class="section-title">借款帳戶資訊</div>
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item">
                        <div class="label">借款帳戶</div>
                        <div class="value">{{ documentDetail.loanBankName }}</div>
                    </div>
                    <div class="item">
                        <div class="label">還款日期</div>
                        <div class="value">{{ documentDetail.repaymentDate | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">還款總額</div>
                        <div class="value xl"><Money :v="documentDetail.principalAmount + documentDetail.interestAmount" /><span class="cny">TWD</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        datas: {
            type: Object,
            default: () => {},
        },
    },
    components: { },
    data() {
        return {
        };
    },
    computed: {
        documentDetail() {
            return this.datas.detail || {};
        },
    },
    methods: {
    },
};
</script>
